import { Observable, observe, Scope } from 'wdc-cube'
import { CampoFonteDadosEnum } from '../regra.types'
import { Cfop } from 'src/modules/motor-credito/cfop/cfop.types'

@Observable
export class CondicaoFormScope extends Scope {
    @observe() idSelected = 0 as number

    @observe() fonteDados = 'CFOP' as string
    @observe() cfops = [] as Cfop[]
    @observe() campoFonteDados = '' as CampoFonteDadosEnum
    @observe() comparacao = 'IGUAL' as string
    @observe() valor1 = '' as string
    @observe() valor2 = '' as string
    @observe() tipo = 'E' as 'E' | 'OU'

    onSave = Scope.ASYNC_ACTION
    onClose = Scope.ASYNC_ACTION
}

export default CondicaoFormScope
